/**
 * VerifiedDot — a tiny red dot indicating Portfolio-tier membership, rendered
 * next to the photographer's name on photo cards, detail pages, and profiles.
 *
 * Shown only when `visible` is true. Accessible label + title for hover.
 */
import { useLang } from "../contexts/LanguageContext";

export default function VerifiedDot({ visible, size = 8, className = "" }) {
  const { t } = useLang();
  if (!visible) return null;
  return (
    <span
      className={`inline-block rounded-full bg-sienna align-middle ${className}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label={t("verified")}
      title={t("verified")}
      data-testid="verified-dot"
    />
  );
}
